// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"118":"56ff1056","279":"8120316b","344":"026f94c9","391":"31378d30","697":"55df4c06","821":"82c7ab1d"}[chunkId] + ".css";
};